import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LoginModel } from '../model/login.model';
import { LocalStorageService } from './localstorage.service';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  HabilitacaoSwapModel,
  SocioModel,
  HistoricoSwapModel,
} from '../habilitacao-swap/models';
import { KycRequestViewModel, KycResponse } from '../habilitacao-swap/models/kyc.model';
import { delay, of } from 'rxjs';
import { ApiResponse } from '../macro-posto/models';
import { CONFIG_URLS_API } from 'src/environments/config-envs';



@Injectable({
  providedIn: 'root',
})


export class HabilitacaoSwapService {
  private readonly http = inject(HttpClient);
  private readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  public usuario!: LoginModel;


  constructor(
    private localStorageService: LocalStorageService
  ) {

    var userData = this.localStorageService.getItem('userData');

    if (userData != null) {
      this.usuario = JSON.parse(userData);
    }
  }

  // ==================== Mock Data ====================
  private Socios: SocioModel[] = [];

  private Historicos: HistoricoSwapModel[] = [];

  private nextId = 0;

  // ==================== Consultar Habilitação ==================== 
  
  buscarHabilitacao(payload: KycRequestViewModel): Observable<HabilitacaoSwapModel | null> {
    return this.consultaDadosTela(payload).pipe(
      map((dados: any) => {
        if (dados) {
          const listaSociosJson = dados.socios || dados.Socios || [];
          const listaHistorico = dados.historicos || dados.Historicos || [];
          
          this.Socios = listaSociosJson.map((s: any) => SocioModel.fromJson(s));
          this.Historicos = listaHistorico.map((h: any) => HistoricoSwapModel.fromJson(h));
          
          return new HabilitacaoSwapModel(
            dados.id || 1,
            dados,
            dados.status || dados.Status,
            dados.dataLiberacao || dados.DataLiberacao || null,
            this.Socios,
            this.Historicos,
            '2026-02-22T09:15:00',
            dados.msgRetornoSwap || dados.MsgRetornoSwap || '',
          );
        }
        return null;
      })
    );
  }
  

  // ==================== Sócios ====================

  buscarSocios(): Observable<SocioModel[]> {
    return of([...this.Socios]).pipe(delay(300));
  }

  salvarSocio(socio: SocioModel): Observable<ApiResponse<any>> {
    socio.codKycSocio = this.nextId++;
    this.Socios.push(socio);    

    return of({ sucesso: true, retorno: socio.toJson(), mensagens: [] }).pipe(delay(400));
  }

  editarSocio(socio: SocioModel): Observable<ApiResponse<any>> {
    const index = this.Socios.findIndex(s => s.codKycSocio === socio.codKycSocio);
    if (index !== -1) {
      this.Socios[index] = socio;
    }
    return of({ sucesso: true, retorno: socio.toJson(), mensagens: [] }).pipe(delay(400));
  }

  removerSocio(idSocio: number): Observable<ApiResponse<any>> {
    const socio = this.Socios.find(s => s.codKycSocio === idSocio);
    console.log('Socio a ser removido:', socio);
    
    this.Socios = this.Socios.filter(s => s.codKycSocio !== idSocio);
    console.log('Sócios após remoção:', this.Socios);
    
    return of({ sucesso: true, retorno: null, mensagens: [] }).pipe(delay(300));
  }


  submeterParaValidacao(
    payload: KycRequestViewModel
  ): Observable<KycResponse> {
    const url = `${environment.host_ctf_service}${CONFIG_URLS_API.API_processar_kyc}`;
    // Passamos o guid na query string se o backend exigir, ou apenas no body como está no model
    const urlWithGuid = `${url}`;
    return this.http.post<KycResponse>(urlWithGuid, payload, this.httpOptions);
  }

  consultaDadosTela(payload: KycRequestViewModel): Observable<KycRequestViewModel> {
    let dadosChamada:  any;
    dadosChamada = {
      Guid: payload.Guid,
      CodTipoEntidade: payload.CodTipoEntidade
    };

    const url = `${environment.host_ctf_service}${CONFIG_URLS_API.API_consultar_kyc}`;
    return this.http.post<any>(url, dadosChamada, this.httpOptions).pipe(
      map(response => response.retorno)
    );
  }
  // ==================== Histórico ====================

  buscarHistorico(): Observable<HistoricoSwapModel[]> {
    return of([...this.Historicos]).pipe(delay(300));
  }
}
